import { render, staticRenderFns } from "./Ordermanagement.vue?vue&type=template&id=36546cdb&scoped=true&"
import script from "./Ordermanagement.vue?vue&type=script&lang=js&"
export * from "./Ordermanagement.vue?vue&type=script&lang=js&"
import style0 from "./Ordermanagement.vue?vue&type=style&index=0&id=36546cdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36546cdb",
  null
  
)

export default component.exports